import { Pipe, PipeTransform } from '@angular/core';
import { enumLeadRequestStatus } from '../socialtravels/user/user-leads/user-leads.component';

@Pipe({
  name: 'leadStatus'
})
export class LeadStatusPipe implements PipeTransform {

  transform(value: enumLeadRequestStatus, ...args: unknown[]): string {
    switch(value){
      case enumLeadRequestStatus.INVIATO:
        return `<span class="lead-status inviato">Inviato</span>`
      case enumLeadRequestStatus.ANNULLATO:
        return `<span class="lead-status annullato">Annullato</span>`
      case enumLeadRequestStatus.NUOVO:
        return `<span class="lead-status nuovo">Nuovo</span>`
      case enumLeadRequestStatus.RICHIESTA_MODIFICA:
        return `<span class="lead-status modifica">Richiesta modifica</span>`
    }
    return ""
  }

}
